import { getRequest } from "../utils";
import { DefaultClass } from "../classes/DefaultClass";
import api from "@shop/frontend/web/js/api";
import {Modal} from "@shop/frontend/web/js/components/Modal";

const csrfToken = $("meta[name='csrf-token']").attr("content");

class Order extends DefaultClass {
	constructor() {
		super();
		this.$open = $(".js-bookings-open");
		this.parent = this.$open.parents(".bookings");
		this.$bookingsWrapper = this.parent.find(".js-bookings-wrapper");
		this.$delete = $(".js-order-delete");
		this.$bookingDelete = this.parent.find(".js-booking-delete");
		this.$count = this.parent.find(".js-bookings-count");
		this.ordersCount = $(".js-order").length;
		this.ordersTypeButton = $(".js-order-type");
		this.$clearButton = $("#js-order-clear");
	}

	init() {
		this.getDelete();
		this.deleteFromCart();
		this.removeFull();
		this.initTicketReturn();
		this.actionToChangeOrder();
		this.setUpListeners();
		if ($("[data-acquiring-id]").length > 0) this.initAcquirings();
	}

	setUpListeners () {
		$(document).on("click", ".js-collective-buy", (e) => {
			const $currentTarget = $(e.currentTarget);

			if ($currentTarget.hasClass("order__collective-button_disabled")) {
				return;
			}
			const $orderItem = $currentTarget.parents(".order__item");

			this.currentOrderId = $currentTarget.parents(".js-order").attr("data-id");
			this.currentEventId = $orderItem.find(".order__sub-event").attr("data-event");

			$("#collective-purchase-modal").modal('show');
		});
		this.collectivePurchaseModal = null;

		if ($('#collective-purchase-modal').length) {
			this.collectivePurchaseModal = new Modal();
			this.collectivePurchaseModal.use('collective-purchase-modal');
		}

		$('.js-make-order-collective').on('click', async () => {
			try {
				await api.bulkBuyTeacher.makeOrderBulk(this.currentOrderId, this.currentEventId);
				$(location).prop('href', `${window.location.origin}/collective-purchase`);
			} catch (e) {
				console.log(e);
				this.collectivePurchaseModal.hide();
				this.$modalContent.html(JSON.parse(e).error);
				this.$modal.addClass("collective-purchase-modal");
				this.$modal.modal("show");
				this.$modal.on('hide', () => window.location.reload());
			}
		});

		$("#js-popup-modal .modal__close").on("click", (e) => {
			if (window.location.pathname.includes("event")) {
				window.location.assign("/");
			}
		});
	}

	getDelete() {
		this.$delete.on("click", e => {
			const elem = $(e.currentTarget);
			const id = elem.data("orderId");
			getRequest("/event/cart/get-delete", { id }, "POST", false).then(response => {
				this.$modalContent.html(response);
				this.$modal.addClass("modal_subscription");
				this.$modal.modal("show");
			});
		});
	}

	deleteFromCart() {
		this.$bookingDelete.on("click", e => {
			const close = $(e.currentTarget);
			const order = close.parents(".js-order");
			const bookingsCount = order.find(".js-booking-open");
			const booking = close.parents(".bookings__item");
			this.eventId = booking.data("event-id");
			this.subEventId = booking.data("subEventId");

			this.removeSubscriptionEventSids().then(response => {
				if (response.result) {
					booking.remove();
					this.$count.text(Number(this.$count.text()) - 1);
					bookingsCount.text(Number(bookingsCount.text()) - 1);
					if (Number(this.$count.text()) === 0) {
						if (this.ordersCount > 1) {
							order.remove();
						} else {
							window.location.reload();
						}
					}

					let sum = 0;
					$.each($(".js-booking"), (index, elem) => {
						const bookingItem = $(elem);
						const bookingSum = Number(bookingItem.find(".js-booking-sum").text());
						sum += bookingSum;
					});
					order.find(".js-sum").text(sum);
					this.getCartCount();
				}
			});
		});
	}


	removeFull() {
		this.$clearButton.on("click", () => {
			$.ajax({
				url: "/order/cancel-all",
				type: "POST",
				success: () => {
					window.location.reload();
				},
			});
		});
	}

	initAcquirings() {
		$.each($("[data-acquiring-id]"), (i, $acquiring) => {
			if (!$($acquiring).find(".order__button-link").attr("href")) return true;

			$($acquiring).on("click", e => {
				e.preventDefault();
				const acquiringId = $($acquiring).attr("data-acquiring-id");
				const orderId = $($acquiring)
					.parents(".js-order")
					.attr("data-id");

				getRequest(`/pay/${orderId}/${acquiringId}`)
					.then(res => {
						if (!res.result) throw new Error();
						if ($($acquiring).hasClass("js-get-fast-registration")) return true;

						return (window.location.href = $($acquiring).find(".order__button-link").attr("href"));
					})
					.catch(err => {
						if ($($acquiring).hasClass("js-get-fast-registration"))
							$("#fastRegisterModal").modal("hide");
						alert("Не удалось сменить способ оплаты!");
						console.log(err);
					});
			});
		});
	}

	initTicketReturn() {
		const $ticketReturn = $(".js-ticket-return");
		const $popupModal = $("#js-popup-modal");
		const $templateRefund = $("#js-template-refund");
		const $templateRefundSuccess = $("#js-template-refund-success");
		let orderEvent;
		let wasRefund;
		let $thisTicketReturn;
		let $tickets;
		let $orderDownload;
		let $orderSuccess;

		$ticketReturn.on("click", e => {
			const $element = $(e.currentTarget);
			$thisTicketReturn = $element;
			const orderId = $element.data("order");
			const eventId = $element.data("event");
			const fragment = document.importNode($templateRefund[0].content, true);
			const returnConfirm = $(fragment).find("#js-return-confirm");
			returnConfirm.data("order", orderId);
			returnConfirm.data("event", eventId);
			orderEvent = $element.parents(".history__inner");
			$orderSuccess = orderEvent.find(".history__item:first-child");
			wasRefund = orderEvent.find(".order__was-refund-btn");
			$tickets = orderEvent.find(".tickets");
			$orderDownload = orderEvent.find(".history__download");
			$popupModal.find(".modal-body").html(fragment);
			$popupModal.addClass("modal_refund");
			$popupModal.modal();
		});

		$(document).on("click", "#js-return-confirm", e => {
			const $element = $(e.currentTarget);
			const order_id = $element.data("order");
			const event_id = $element.data("event");
			$.ajax({
				url: "/refund",
				data: { order_id, event_id },
				type: "POST",
				beforeSend: () => {
					$("#js-overlay").show();
				},
				success: response => {
					const res = JSON.parse(response);
					if (res.success) {
						const fragment = document.importNode(
							$templateRefundSuccess[0].content,
							true,
						);
						$popupModal.find(".modal-body").html(fragment);
						$popupModal.addClass("modal_refund-success");
						wasRefund.show();
						$thisTicketReturn.hide();
						$orderDownload.hide();
						$orderSuccess.removeClass("history__item_success");
						$tickets.addClass("tickets_inactive");
					} else {
						alert(res.message);
					}
				},
				complete: () => {
					$("#js-overlay").hide();
				},
				error: error => {
					alert(error);
				},
			});
		});
	}

	actionToChangeOrder() {
		this.ordersTypeButton.on("click", e => {
			const $button = $(e.currentTarget);
			const type = $button.data("type");
			this.ordersTypeButton.removeClass("order__info-item_primary");
			$button.addClass("order__info-item_primary");
			if (type === "sub") {
				$(".order__item").each(function() {
					$(this).hide();

					if ($(this).data("sub")) {
						$(this).show();
					}
				});
				$('.order__low[data-is-sub="true"]').show();
				$('.order__low[data-is-sub="false"]').hide();
			} else {
				$(".order__item").each(function() {
					$(this).show();

					if ($(this).data("sub")) {
						$(this).hide();
					}
				});

				$('.order__low[data-is-sub="true"]').hide();
				$('.order__low[data-is-sub="false"]').show();
			}
		});
	}
}

new Order().init();
